<template>
  <div class="layout-container">
    <Header :is-menu-collapsed="isMenuCollapsed" @toggle-menu="toggleMenu" />
    <main class="main-content">
      <SideCollapseMenu :collapsed="isMenuCollapsed" />
      <div class="wrapper" ref="wrapper">
        <div class="page-shell">
          <div class="page-main">
            <router-view />
          </div>
        </div>
        <Footer />
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import { computed, nextTick, ref, watch } from 'vue'
import { useBreakpoints } from '@vueuse/core'
import SideCollapseMenu from '@/layouts/components/SideMenu/index.vue'
import Footer from '@/layouts/components/Footer/index.vue'
import Header from '@/layouts/components/Header/index.vue'
import { useRoute } from 'vue-router'
import { useToken } from '@/composables/useToken'
import { useBalance } from '@/composables/useBalance'
const { isLoggedIn } = useToken()
const { refreshBalance } = useBalance()
const isMenuCollapsed = ref(false)
const MENU_COLLAPSE_BREAKPOINT = 1100
// 根据设计稿，当屏幕宽度小于1100px时，默认折叠菜单
const breakpoints = useBreakpoints({
  lg: MENU_COLLAPSE_BREAKPOINT
})
const isSmallViewport = breakpoints.smaller('lg')

const toggleMenu = () => {
  isMenuCollapsed.value = !isMenuCollapsed.value
}

const route = useRoute()
const wrapper = ref<HTMLElement | null>(null)

watch(
  () => route.fullPath,
  async (newPath, oldPath) => {
    if (newPath !== oldPath) {
      await nextTick()
      wrapper.value?.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    }
  }
)

watch(
  () => isLoggedIn.value,
  () => {
    // 登录后更新余额数据
    refreshBalance()
  }
)

watch(
  isSmallViewport,
  (small) => {
    isMenuCollapsed.value = small
  },
  { immediate: true }
)
</script>

<style scoped lang="scss">
.layout-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.main-content {
  width: 100%;
  display: flex;
  min-height: 700px;
  max-height: 100dvh;
  overflow: auto;
  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    overflow-y: auto;

    .page-shell {
      display: flex;
      max-width: 1100px;
      width: 1100px;
      flex-direction: column;
      align-items: stretch;
    }

    .page-main {
      min-width: 0;
    }
  }
}
</style>
